// Mirrors the real booking modal so the swap doesn't jump. Rendered inside
// .sf-bk-overlay/.sf-bk-modal so it inherits the modal's tokens and chrome.
// The modal is two steps, and this mirrors the first: its heading, then the
// services, staff and date/time blocks, in that order.
import "./bookingModalSkeleton.css";

export default function BookingModalSkeleton() {
	return (
		<div className="sf-bk-overlay sf-bks">
			<div className="sf-bk-modal">
				{/* HEADER */}
				<div className="sf-bk-header">
					<div className="sf-bks-box sf-bks-back" />
					<div className="sf-bks-box sf-bks-title" />
				</div>

				<div className="sf-bk-body">
					{/* STEP HEADING */}
					<div className="sf-bks-section sf-bks-stephead">
						<div className="sf-bks-box sf-bks-steptitle" />
						<div className="sf-bks-box sf-bks-stephint" />
					</div>

					{/* SERVICES */}
					<div className="sf-bks-section">
						<div className="sf-bks-box sf-bks-label" />
						<div className="sf-bks-box sf-bks-service" />
						<div className="sf-bks-box sf-bks-select" />
					</div>

					{/* STAFF */}
					<div className="sf-bks-section">
						<div className="sf-bks-box sf-bks-label" />
						<div className="sf-bks-box sf-bks-staff" />
					</div>

					{/* WHEN */}
					<div className="sf-bks-section">
						<div className="sf-bks-box sf-bks-label" />

						<div className="sf-bks-weekhead">
							<div className="sf-bks-box sf-bks-navbtn" />
							<div className="sf-bks-box sf-bks-week" />
							<div className="sf-bks-box sf-bks-navbtn" />
						</div>

						<div className="sf-bks-days">
							{Array.from({ length: 7 }).map((_, i) => (
								<div className="sf-bks-box sf-bks-day" key={i} />
							))}
						</div>

						<div className="sf-bks-box sf-bks-periods" />

						<div className="sf-bks-slots">
							{Array.from({ length: 6 }).map((_, i) => (
								<div className="sf-bks-box sf-bks-slot" key={i} />
							))}
						</div>
					</div>
				</div>

				{/* FOOTER */}
				<div className="sf-bk-footer">
					<div className="sf-bks-box sf-bks-summary" />
					<div className="sf-bks-box sf-bks-confirm" />
				</div>
			</div>
		</div>
	);
}
